(function (angular) {
    'use strict';

    angular.module('appMessaging')
        /**
         *
         */
        .controller('PushCtrl',
            ['$scope', 'pushService', 'pushData', '$stateParams', '$uibModal', '$state', 'growlService',
                function ($scope, pushService, pushData, $stateParams, $uibModal, $state, growlService) {
                    $scope.pushData = pushData;
                    $scope.isExpired = function (date) {
                        return new Date() > new Date(date);
                    };
                    $scope.getIsoDate = function (date) {
                        return (new Date(date)).toLocaleDateString();
                    };

                    $scope.openApnsTokenConfigDialog = function () {

                        var modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'components/channels/appMessaging/templates/apns-token-setup-modal.html',
                            controller: 'apnsTokenConfigModal',
                        });

                        modalInstance.result.then(function (data) {
                            $scope.pushData = data;
                        }, function () {

                        });
                    }

                    $scope.openApnsConfigDialog = function () {
                        var modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'components/channels/appMessaging/templates/apns-setup-modal.html',
                            controller: 'apnsConfigModal',
                        });

                        modalInstance.result.then(function (data) {
                            $scope.pushData = data;
                        }, function () {

                        });
                    };
                    $scope.openFcmConfigDialog = function (name, serverKey, privateKey) {
                        serverKey = serverKey || "";
                        name = name || "";
                        privateKey = privateKey || { keyName: "" };

                        var modalInstance = $uibModal.open({
                            animation: true,
                            size: 'md',
                            templateUrl: 'components/channels/appMessaging/templates/fcm-setup-modal.html',
                            controller: 'fcmConfigModal',
                            resolve: {
                                name: function () {
                                    return name;
                                },
                                serverKey: function () {
                                    return serverKey;
                                },
                                privateKeyName: function () {
                                    return privateKey.keyName;
                                }
                            }
                        });

                        modalInstance.result.then(function (data) {
                            $scope.pushData = data;

                        }, function (error) {

                        });
                    };
                    $scope.deleteFcm = function (name) {
                        pushService.delPushFCMConfig($stateParams.pickedApiSpaceId, name).then(function (ret) {
                            growlService.success('FCM deleted');
                            $scope.pushData = ret;
                        }).catch(function (error) {
                            growlService.danger("FCM wasn't deleted due to: " + error.statusText);
                        });
                    };
                    $scope.deleteApns = function (bundleId, type) {
                        pushService.delPushAPNSConfig($stateParams.pickedApiSpaceId, bundleId, type).then(function (ret) {
                            growlService.success('APNS deleted');
                            $scope.pushData = ret;
                        }).catch(function (error) {
                            growlService.danger("APNS wasn't deleted due to: " + error.statusText);
                        });
                    };

                    $scope.deleteApnsToken = function (bundleId, type) {
                        pushService.delPushAPNSTokenConfig($stateParams.pickedApiSpaceId).then(function (ret) {
                            growlService.success('APNS Token deleted');
                            $scope.pushData = ret;
                        }).catch(function (error) {
                            growlService.danger("APNS Token wasn't deleted due to: " + error.statusText);
                        });
                    };

                }])
        /**
         *
         */
        .controller('apnsTokenConfigModal', ["$scope", "$uibModalInstance", "pushService", '$stateParams', 'growlService',
            function ($scope, $uibModalInstance, pushService, $stateParams, growlService) {
                $scope.file = {};
                $scope.ok = function () {

                    pushService.setAPNSTokenConfig($stateParams.pickedApiSpaceId, $scope.file.data, $scope.keyId, $scope.teamId).then(function (ret) {
                        growlService.success('APNS Token created');
                        $uibModalInstance.close(ret);
                    }).catch(function (error) {
                        let message = "";
                        if (error.data && error.data.validationFailures) {
                            for (let i = 0; i < error.data.validationFailures.length; i++) {
                                message += error.data.validationFailures[i].message;
                                if (i !== error.data.validationFailures.length - 1) {
                                    message += ", ";
                                }
                            }
                        } else {
                            message = error.statusText;
                        }
                        growlService.danger("APNS wasn't created due to: " + message);
                        $uibModalInstance.dismiss();
                    });
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

            }])
        .controller('apnsConfigModal', ["$scope", "$uibModalInstance", "pushService", '$stateParams', 'growlService',
            function ($scope, $uibModalInstance, pushService, $stateParams, growlService) {
                $scope.file = {};
                $scope.ok = function () {
                    pushService.setAPNSPushConfig($stateParams.pickedApiSpaceId, $scope.file.data, $scope.password).then(function (ret) {
                        growlService.success('APNS created');
                        $uibModalInstance.close(ret);
                    }).catch(function (error) {
                        growlService.danger("APNS wasn't created due to: " + error.statusText);
                        $uibModalInstance.dismiss();
                    });
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

            }])
        .controller('fcmConfigModal', ["$scope", "$uibModalInstance", "pushService", '$stateParams', 'serverKey', 'name', 'privateKeyName', 'growlService',
            function ($scope, $uibModalInstance, pushService, $stateParams, serverKey, name, privateKeyName, growlService) {
                $scope.file = {};
                $scope.name = name;
                $scope.serverKey = serverKey;
                $scope.privateKeyName = privateKeyName;

                const hasPrivateKey = !!privateKeyName && privateKeyName !== '';
                const hasServerKey = !!serverKey && serverKey !== '';
                const serverKeyDeprecationDate = new Date(2024, 5, 20);
                const serverKeyDeprecated = new Date() >= serverKeyDeprecationDate;
                $scope.isEditingMode = hasPrivateKey || hasServerKey;

                $scope.showServerKeyInput = !serverKeyDeprecated && serverKey !== '' && !hasPrivateKey;
                $scope.showPrivateKeyInput = hasPrivateKey;
                $scope.ok = function () {
                    pushService.setFCMPushConfig($stateParams.pickedApiSpaceId, $scope.name, $scope.serverKey, $scope.file.data).then(function (ret) {
                        growlService.success('FCM created');
                        $uibModalInstance.close(ret);
                    }).catch(function (error) {
                        growlService.danger("FCM wasn't created due to: " + error.statusText);
                        $uibModalInstance.dismiss('cancel');
                    });
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

            }]);


})(window.angular);
